import url from "./url";
import tracks from "./tracks";

const reducers = {
  url,
  tracks,
};

export default reducers;
